module.exports = __webpack_public_path__ + "media/images/invoice-logo-4da1f8264f8d629a8aa65a03942c90ab.png";